import React from "react";
import { HERO_IMAGE } from "../lib/constants";

export default function AuthShell({ title, subtitle, children }) {
  return (
    <div className="min-h-screen md:grid md:grid-cols-2 bg-[#FCFBF8]">
      <div className="relative hidden md:block">
        <img src={HERO_IMAGE} alt="Fresh market produce" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#0A1F13]/60" />
        <div className="relative h-full flex flex-col justify-between p-12 text-white">
          <div className="self-start bg-white rounded-2xl px-4 py-2.5 shadow-lg">
            <img src="/ayome_logo.png" alt="Ayome Groceries" className="h-12 w-auto object-contain" />
          </div>
          <div>
            <h2 className="font-display text-4xl font-bold leading-tight">
              Fresh from the market,<br />delivered to your door.
            </h2>
            <p className="mt-4 text-white/80 max-w-md">
              Order authentic Nigerian groceries during Market Day. Bank transfer only — no card needed.
            </p>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center px-6 py-12 min-h-screen md:min-h-0">
        <div className="w-full max-w-sm animate-fade-up">
          <div className="md:hidden mb-8 flex justify-center">
            <img src="/ayome_logo.png" alt="Ayome Groceries" className="h-14 w-auto object-contain" />
          </div>
          <h1 className="font-display text-3xl font-bold text-[#0A1F13] tracking-tight">{title}</h1>
          {subtitle && <p className="mt-2 text-gray-500">{subtitle}</p>}
          <div className="mt-8">{children}</div>
        </div>
      </div>
    </div>
  );
}
